/**
 * Inline Canadian flag — SVG so it renders consistently on every OS/browser
 * (the 🇨🇦 emoji falls back to literal "CA" on many desktop Linux builds).
 */
export default function CanadaFlag({ className = "w-6 h-4", title = "Made in Canada" }) {
  return (
    <svg
      role="img"
      aria-label={title}
      className={className}
      viewBox="0 0 60 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <rect width="60" height="30" fill="#fff" />
      <rect width="15" height="30" fill="#D52B1E" />
      <rect x="45" width="15" height="30" fill="#D52B1E" />
      {/* Simplified 11-point Canadian maple leaf */}
      <path
        transform="translate(30 15) scale(0.11)"
        fill="#D52B1E"
        d="M0-90 8-70 27-77 20-56 40-50 26-38 32-25 12-27 15-4 0-15 -15-4 -12-27 -32-25 -26-38 -40-50 -20-56 -27-77 -8-70 Z"
      />
    </svg>
  );
}
